type Props = {
  fill?: string;
  width?: number;
  height?: number;
};
function LabSvg(props: Props) {
  const { fill, width = 12, height = 13 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 12 13" fill="none">
      <g clipPath="url(#clip0_8478_86344)">
        <path
          d="M8.25 4.10675V2H9.75V0.5H2.27325V2H3.75V4.10675C2.89211 4.60205 2.22163 5.36659 1.84254 6.28179C1.46346 7.19699 1.39695 8.2117 1.65334 9.16855C1.90972 10.1254 2.47468 10.9709 3.26058 11.574C4.04647 12.177 5.0094 12.5039 6 12.5039C6.99061 12.5039 7.95353 12.177 8.73943 11.574C9.52533 10.9709 10.0903 10.1254 10.3467 9.16855C10.6031 8.2117 10.5365 7.19699 10.1575 6.28179C9.77837 5.36659 9.10789 4.60205 8.25 4.10675ZM5.25 5.10575V2H6.75V5.10575C7.31597 5.2524 7.82675 5.56123 8.21955 5.99428C8.61236 6.42732 8.87007 6.96571 8.961 7.54325C7.95202 7.3082 6.89125 7.47183 6 8C5.11114 8.5271 4.05329 8.69123 3.0465 8.45825C3.01918 8.30693 3.00363 8.15372 3 8C3.0013 7.33645 3.22299 6.69212 3.63025 6.16825C4.03751 5.64438 4.60726 5.27064 5.25 5.10575Z"
          fill={fill ?? "#1064DB"}
        />
      </g>
    </svg>
  );
}

export default LabSvg;
